import Swiper, { Navigation, Pagination, Autoplay, Thumbs, Scrollbar, Controller } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Scrollbar, Controller]);

$(function () {
    // home - hero slider
   /* if($('#hero-slider').length){
        new Swiper('#hero-slider', {
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            speed: 400,
            autoplay: {
                delay: 5000
            },
        });
    }*/

    // home - 3 widget intro slider
    if($('.intro-swiper-container').length){
        new Swiper('.intro-swiper-container', {
            slidesPerView: 'auto',
            loop: false,
            spaceBetween: 30,
            autoplay: {
                delay: 2500
            },
            breakpoints: {
                640: {
                    slidesPerView: 3
                },
            },
            pagination: {
                el: '.swiper-pagination',
            },
        });
    }

    // home - product trending slider
    if($('.trending-swiper-container').length){
        new Swiper('.trending-swiper-container', {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 10,
            autoplay: {
                delay: 2500
            },
            breakpoints: {
                640: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },

                992: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                },

                1600: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                },
            }
        });
    }


    // company brand slider
    if($('.footer-swiper-container').length){
        new Swiper('.footer-swiper-container', {
            slidesPerView: 2,
            loop: false,
            spaceBetween: 10,
            autoplay: {
                delay: 2500
            },
            breakpoints: {
                640: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }
        });
    }

    //product gallery slider
    if($('.product__images-container').length){
        if($('.product__images-container .swiper-slide').length > 1){
            var galleryThumbs = new Swiper('.product__thumbnails-container', {
                spaceBetween: 10,
                slidesPerView: 'auto',
                freeMode: true,
                loopedSlides: 5, //looped slides should be the same
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            new Swiper('.product__images-container', {
                spaceBetween: 0,
                loop: true,
                slidesPerView: 1,
                loopedSlides: 5, //looped slides should be the same
                thumbs: {
                    swiper: galleryThumbs,
                }
            });
        }else{
            $('.product__thumbnails-container').remove();
        }
    }

});